export const AVAILABLE_ROLES = {
  SUPERUSER: "SUPERUSER",
  ADMIN: "ADMIN",
  SUPERVISOR: "SUPERVISOR",
  MANAGER: "MANAGER",
};
